module.exports = __webpack_public_path__ + "img/ic_default_hub.a118301b.svg";